import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {AdvancedGamesFilterDefaultBox} from "./advanced-games-filter.default.box";
import {AdvancedGamesFilterMrgreenBox} from "./advanced-games-filter.mrgreen.box";

export const AdvancedGamesFilterBox = styledByTheme(AdvancedGamesFilterDefaultBox)
    .forMrGreen(AdvancedGamesFilterMrgreenBox)
    .apply()
